/**
 * First-visit welcome panel persistence for client-facing proposal views.
 * Scoped to this browser + proposal version so one viewer dismissing it
 * does not hide it for everyone else.
 */

export const PROPOSAL_WELCOME_STORAGE_PREFIX = 'mayker.proposalWelcome.v1';

export function getProposalWelcomeStorageKey({ projectNumber, version } = {}) {
  const project = String(projectNumber || '').trim() || 'unknown';
  const ver = version === undefined || version === null || String(version).trim() === ''
    ? '1'
    : String(version).trim();
  return `${PROPOSAL_WELCOME_STORAGE_PREFIX}:${project}:${ver}`;
}

function readStorage(storage) {
  if (storage) return storage;
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function hasDismissedProposalWelcome(key, storage) {
  const store = readStorage(storage);
  if (!store || !key) return false;
  try {
    return store.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function markProposalWelcomeDismissed(key, storage) {
  const store = readStorage(storage);
  if (!store || !key) return false;
  try {
    store.setItem(key, '1');
    return true;
  } catch {
    return false;
  }
}
